import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Home from "./pages/Home/Home";
import Header from "./components/Header/Header";
import "./util/global.css";
import Footer from "./components/Footer/Footer";
import Services from "./pages/Services/Services";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import AboutUs from "./pages/AboutUs/AboutUs";
import Contact from "./pages/Contact/Contact";
import Impressum from "./pages/Legal/Impressum";
import Datenschutz from "./pages/Legal/Datenschutz";
import Haftungsausschluss from "./pages/Legal/Haftungsausschluss";
import AGB from "./pages/Legal/AGB";
import Links from "./pages/Links/Links";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import CookieSettings from "./pages/Legal/CookieSettings";
import MatelsoSpaScan from "./components/MatelsoSpaScan/MatelsoSpaScan";

import { loadGoogleTag, setConsentDefaultsDenied } from "./util/gtag";

// Läuft INNERHALB vom <Router>, damit useLocation funktioniert
function GtagRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;

    const page_path = location.pathname + location.search;

    window.gtag("event", "page_view", {
      page_path,
    });
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  // 1) Global einmal: consent default denied + gtag.js laden
  useEffect(() => {
    try {
      setConsentDefaultsDenied();
      loadGoogleTag().catch(console.error);
    } catch (err) {
      console.error(err);
    }
  }, []);

  return (
    <Router>
      {/* 2) SPA: page_view bei Route-Changes */}
      <GtagRouteTracker />

      <MatelsoSpaScan />
      <ScrollToTop />
      <CookieBanner />
      <Header />

      <div className="layout">
        <main className="page">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/cookies" element={<CookieSettings />} />
            <Route path="/haftungsausschluss" element={<Haftungsausschluss />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/links" element={<Links />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
